<template>
  <div id="app">
    <section
      :style="{ backgroundColor: getHeaderColor(getCurrentRoom()) }"
      class="header"
    >
      <div class="container">
        <img
          src="../images/logoAgendaByDayBanner.png"
          alt=""
          width="891"
          height="144"
        />
        <h1>{{ getCurrentRoom() }}</h1>
      </div>
    </section>
    <section class="main-section">
      <div class="container">
        <!-- <div class="sponsor-wrapper">
          <div class="sponsor-head">
            <h5>Sponsored by</h5>
          </div>
          <div class="sponsor-logo">
            <img src="images/logo-1.jpg" alt="" />
          </div>
        </div> -->
        <div
          class="agenda-wrapper"
          v-for="(agenda, index) in filteredAgendaList"
          :key="`${agenda.id}-${refreshKey}`"
          :style="
            index !== filteredAgendaList.length - 1
              ? {
                  borderBottom:
                    '10px solid ' + getHeaderColor(getCurrentRoom()),
                }
              : {}
          "
        >
          <div class="agenda-left">
            <h2
              :style="{ color: getHeaderColor(getCurrentRoom()) }"
              v-if="isCurrentSession(agenda)"
            >
              WHAT'S ON NOW
            </h2>
            <h2
              :style="{ color: getHeaderColor(getCurrentRoom()) }"
              v-else-if="isNextSession(agenda)"
            >
              WHAT'S ON NEXT
            </h2>
            <h3 :style="{ color: getHeaderColor(getCurrentRoom()) }">
              {{ formatTime(agenda.startTime) }} -
              {{ formatTime(agenda.endTime) }}
            </h3>
          </div>
          <div class="agenda-right">
            <h4 :style="{ color: getHeaderColor(getCurrentRoom()) }">
              {{ agenda.title }}
            </h4>
            <template v-if="agenda.user && agenda.user.length > 0">
              <h5 :style="{ color: getHeaderColor(getCurrentRoom()) }">
                <strong>Speakers</strong>
              </h5>

              <div v-for="speaker in agenda.user" :key="speaker.id">
                <template v-if="!speaker.isModerator">
                  <p>
                    <template
                      v-if="['H.E.', 'Dr', 'Hon'].includes(speaker.salutation)"
                    >
                      {{ speaker.salutation }}
                    </template>
                    {{ speaker.name }}, {{ speaker.jobTitle }},
                    <strong>{{ speaker.company }}</strong>
                  </p>
                </template>
              </div>

              <div v-if="agenda.user.some((speaker) => speaker.isModerator)">
                <h5 :style="{ color: getHeaderColor(getCurrentRoom()) }">
                  <strong>Moderator</strong>
                </h5>

                <p v-for="speaker in agenda.user" :key="speaker.id">
                  <template v-if="speaker.isModerator">
                    <template
                      v-if="['H.E.', 'Dr', 'Hon'].includes(speaker.salutation)"
                    >
                      {{ speaker.salutation }}
                    </template> {{ speaker.name }},
                    {{ speaker.jobTitle }} –
                    <strong>{{ speaker.company }}</strong>
                  </template>
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
    <section
      :style="{ backgroundColor: getHeaderColor(getCurrentRoom()) }"
      class="footer"
    >
      <div class="container">
        <div class="footer-wrapper">
          <a> @gastechevent </a>
          <a> #Gastech </a>
          <div class="footer-social">
            <a href="https://www.facebook.com/GastechEvent/" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 10.619 23.006"
              >
                <path
                  id="Path_290"
                  data-name="Path 290"
                  d="M1554.639,6133.647h4.632v-11.6h3.232l.345-3.884h-3.577v-2.213c0-.915.184-1.277,1.07-1.277h2.507v-4.031h-3.208c-3.447,0-5,1.518-5,4.424v3.1h-2.41v3.932h2.41Z"
                  transform="translate(-1552.229 -6110.641)"
                  fill="#fff"
                ></path>
              </svg>
            </a>
            <a href="https://x.com/GastechEvent" target="_blank">
              <svg width="30" height="30" viewBox="0 0 512 512">
                <path
                  fill="#fff"
                  d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/c/GastechEvent"
              target="_blank"
              data-feathr-click-track="true"
              data-feathr-link-aids="574f10dc8e8027638b205753"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 21.271 14.986"
              >
                <g
                  id="Group_188"
                  data-name="Group 188"
                  transform="translate(-1718.434 -6114.651)"
                >
                  <path
                    id="Path_299"
                    data-name="Path 299"
                    d="M1739.257,6117a2.69,2.69,0,0,0-1.885-1.9c-1.656-.447-8.3-.447-8.3-.447s-6.647,0-8.315.447a2.671,2.671,0,0,0-1.885,1.9,28.584,28.584,0,0,0-.435,5.149,27.827,27.827,0,0,0,.447,5.148,2.693,2.693,0,0,0,1.885,1.9c1.656.447,8.3.447,8.3.447s6.647,0,8.315-.447a2.671,2.671,0,0,0,1.886-1.9,28.583,28.583,0,0,0,.435-5.148A27.777,27.777,0,0,0,1739.257,6117Zm-12.363,8.315v-6.333l5.559,3.167Z"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/gastechevent"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 19.077 19.086"
              >
                <g
                  id="Group_187"
                  data-name="Group 187"
                  transform="translate(-1776.531 -6111.539)"
                >
                  <g id="Group_186" data-name="Group 186">
                    <rect
                      id="Rectangle_70"
                      data-name="Rectangle 70"
                      width="3.939"
                      height="12.724"
                      transform="translate(1776.909 6117.901)"
                      fill="#fff"
                    ></rect>
                    <path
                      id="Path_297"
                      data-name="Path 297"
                      d="M1778.86,6116.235a2.348,2.348,0,1,0-2.329-2.348A2.339,2.339,0,0,0,1778.86,6116.235Z"
                      fill="#fff"
                    ></path>
                  </g>
                  <path
                    id="Path_298"
                    data-name="Path 298"
                    d="M1787.144,6123.946c0-1.789.823-2.854,2.4-2.854,1.448,0,2.144,1.023,2.144,2.854v6.679h3.92v-8.056c0-3.408-1.932-5.056-4.63-5.056a4.435,4.435,0,0,0-3.834,2.1V6117.9h-3.778v12.724h3.778Z"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment-timezone";
export default {
  name: "onsiteagenda",
  data() {
    return {
      type: "",
      nextSessionId: null,
      currentTime: null,
      refreshKey: 0,
    };
  },
  computed: {
    agendaList: function() {
      return this.$store.state.agendalistInitial.exhibitors;
    },
    filteredAgendaList() {
      if (!this.agendaList || !Array.isArray(this.agendaList)) {
        return []; // Return an empty array if agendaList is not ready
      }
      const currentRoom = this.getCurrentRoom();
      //const currentMoment = moment().tz("America/Chicago");
      //const currentDate = currentMoment.format("YYYY-MM-DD");

      return this.agendaList
        .filter((session) => {
          //   const sessionStart = moment(session.startDateTime);
          //   const sessionEnd = moment(session.endDateTime);
          return (
            session.room === currentRoom
            // &&
            // currentDate === sessionStart.format("YYYY-MM-DD") &&
            // currentMoment.format("YYYY-MM-DD HH:mm:ss") <=
            //   sessionEnd.format("YYYY-MM-DD HH:mm:ss")
          );
        })
        .sort((a, b) => {
          const startA = moment(a.startDateTime);
          const startB = moment(b.startDateTime);
          return startA.valueOf() - startB.valueOf();
        });
    },
  },
  async mounted() {
    this.typeDetermination(); // Refactor type setting logic into a method for clarity
    await this.getAllAgendaList(this.type);
    this.startPeriodicRefresh();
  },
  methods: {
    startPeriodicRefresh() {
      setInterval(() => {
        this.refreshData();
      }, 500000); // 10 minutes 500000
    },
    isCurrentSession(agenda) {
      const now = moment()
        .tz("America/Chicago")
        .format("YYYY-MM-DD HH:mm:ss");
      const sessionStart = moment(agenda.startDateTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const sessionEnd = moment(agenda.endDateTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      return now >= sessionStart && now <= sessionEnd;
    },

    isNextSession(agenda) {
      return agenda.id === this.nextSessionId;
    },
    async refreshData() {
      this.currentTime = moment().tz("America/Chicago");
      await this.getAllAgendaList(this.type);
      this.updateNextSession();
      this.$forceUpdate(); // Force Vue to re-render the component
      this.refreshKey += 1;
      window.location.reload();
    },
    updateNextSession() {
      const now = moment()
        .tz("America/Chicago")
        .format("YYYY-MM-DD HH:mm:ss");
      let nextSession = null;
      for (const session of this.filteredAgendaList) {
        const sessionStart = moment(session.startDateTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        if (sessionStart > now && !this.isCurrentSession(session)) {
          nextSession = session;
          break;
        }
      }
      this.nextSessionId = nextSession ? nextSession.id : null;
    },
    formatTime(time) {
      // Assuming time is in format 'hh:mm AM/PM'
      const [hour, minute, period] = time.split(/:| /);
      let formattedHour = parseInt(hour, 10);

      if (period === "PM" && formattedHour !== 12) {
        formattedHour += 12;
      } else if (period === "AM" && formattedHour === 12) {
        formattedHour = 0;
      }

      return `${formattedHour.toString().padStart(2, "0")}:${minute}`;
    },
    typeDetermination() {
      const pathname = window.location.pathname;
      if (pathname.includes("strategic")) {
        this.type = "Strategic";
      } else if (pathname.includes("technical")) {
        this.type = "Technical Conference";
      } else {
        this.type = "";
      }
    },
    getCurrentRoom() {
      // Get room from URL query parameter
      return this.$route.query.room.replace(/_/g, "&") || "Plenary I"; // Replace 'defaultRoom' with a valid default if necessary
    },
    hasSessionEnded(endDateTime) {
      return moment().isAfter(moment(endDateTime));
    },
    async getAllAgendaList(type) {
      await this.$store.dispatch("agendaInitialList", type);
    },
    getHeaderColor(category) {
      const colors = {
        "Climatetech Strategic": "#9B2A79",
        "Strategy & Leadership": "#273480",
        "Hydrogen Strategic": "#0086a6",
        "Strategic Leadership": "#273480",
        "Climatetech & AI Strategic": "#9B2A79",
        "Climatetech & AI Theater": "#2b2159",
        "Hydrogen Theater": "#00474f",
        Plenary: "#0bbbef",
        "Plenary II": "#0bbbef",
        "Energy Talks": "#22315f",
        "Shipping & Marine": "#54c3bd",
        "Shipping & Marine Theater": "#38516b",
        "EPC & Gas Processing": " #f26c4f",
        "EPC & Gas Processing Theater": "#0e2342",
        "Climatetech & AI": "#9B2A79",
        Hydrogen: "#0086a6",
        Commercial: "#0bbbef",
        "Commercial Theater": "#273480",
        "Feature Programs": "#0bbbef",
        "Future Leaders": "#f6a24a",
        "Procurement Meeting Place": "#22315f",
        "Procurement Meeting Place Theater": "#273480",
        "Diversity, Equity & Inclusion in Energy": "#6f5ca4",
      };
      return colors[category] || "#0bbbef"; // 'defaultColor' is a fallback color
    },
  },
  watch: {
    filteredAgendaList: {
      immediate: true,
      handler() {
        this.updateNextSession();
      },
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

body {
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: #000;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0px;
  padding: 0px;
}

.container {
  padding: 0px 90px;
}

img {
  max-width: 100%;
  height: auto;
}

.header {
  background-color: #2e2d7d;
  padding: 40px 0px;
  text-align: center;
}

h1 {
  font-size: 80px;
  color: #fff;
  font-weight: 400;
  margin-top: 50px;
}

h2 {
  color: #2e2d7d;
  font-size: 40px;
}

.sponsor-head h5 {
  font-size: 30px;
  font-weight: 400;
}

.sponsor-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 25px;
}

.sponsor-head {
  width: 20%;
}

.sponsor-logo {
  width: 80%;
  padding-left: 20px;
}

.main-section {
  padding: 60px 0px;
}

.agenda-wrapper h3 {
  color: #2e2d7d;
  font-size: 30px;
  margin-top: 8px;
}

.agenda-wrapper {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 10px solid #2e2d7d;
  padding-bottom: 50px;
  margin-top: 50px;
}

.agenda-wrapper:last-child {
  border: none;
}

.agenda-wrapper h4 {
  font-size: 40px;
}

.agenda-left {
  width: 20%;
}

.agenda-right {
  width: 80%;
  padding-left: 20px;
}

.agenda-right h5 {
  font-size: 25px;
  margin-top: 20px;
}

p {
  font-size: 20px;
  margin-top: 10px;
}

.footer-wrapper a {
  color: #fff;
  font-size: 35px;
  text-decoration: none;
  padding: 0px 15px;
}

.footer {
  background-color: #2e2d7d;
  padding: 60px 0px;
}

.footer-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.footer-social {
  display: flex;
}

.footer-social a {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
}

.footer-social a svg path {
  fill: #fff;
}

.footer-social a:nth-child(2) svg path {
  stroke: #fff;
}

.footer-social a:nth-child(2) {
  position: relative;
}

.color-2 .header,
.color-2 .footer {
  background-color: #9e2677;
}

.color-2 h2 {
  color: #9e2677;
}

.color-2 .agenda-wrapper h3 {
  color: #9e2677;
}

.color-2 .agenda-wrapper {
  border-color: #9e2677;
}

.color-3 .header,
.color-3 .footer {
  background-color: #395069;
}

.color-3 h2 {
  color: #395069;
}

.color-3 .agenda-wrapper h3 {
  color: #395069;
}

.color-3 .agenda-wrapper {
  border-color: #395069;
}

.color-4 .header,
.color-4 .footer {
  background-color: #0084a4;
}

.color-4 h2 {
  color: #0084a4;
}

.color-4 .agenda-wrapper h3 {
  color: #0084a4;
}

.color-4 .agenda-wrapper {
  border-color: #0084a4;
}

@media screen and (max-width: 1280px) {
  .container {
    padding: 0px 40px;
  }

  .sponsor-head h5,
  .agenda-wrapper h3 {
    font-size: 26px;
  }

  h1 {
    font-size: 70px;
  }

  h2 {
    font-size: 40px;
  }

  .agenda-wrapper h4 {
    font-size: 30px;
  }

  .agenda-right h5 {
    font-size: 20px;
  }

  p {
    font-size: 17px;
  }

  .agenda-wrapper {
    margin-top: 40px;
    padding-bottom: 40px;
  }
}

@media screen and (max-width: 992px) {
  .sponsor-head,
  .agenda-left {
    width: 100%;
  }

  .sponsor-logo,
  .agenda-right {
    width: 100%;
    padding-left: 0;
    margin-top: 15px;
  }

  .footer-wrapper {
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 600px) {
  .container {
    padding: 0px 15px;
  }

  .main-section {
    padding: 30px 0px;
  }
}
</style>
